import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/*
 *  Index Template Scripts
 *    Scripts that are only meant to run on the Index Template.
 *
 *  Version:
 *    1.0.0 - 2020/02/09
 */

//Lity - Resolve issue with Lity not preventing default click
import 'lity/dist/lity';
document.querySelectorAll('[data-lity]').forEach(function (link) {
  link.addEventListener('click', function (e) {
    return e.preventDefault();
  });
});
import './../sections/article-carousel/ArticleCarousel';
import './../sections/art-products-carousel/art-products-carousel';
import './../sections/best-sellers/BestSellers';
import './../sections/hero-carousel/HeroCarousel';
import './../sections/home-testimonials/HomeTestimonials';
import './../sections/products-carousel/ProductsCarousel';
import '../sections/home-message/home-message';

// import '../tools/sections/section-background';
// import './../sections/hero-banner/hero-banner';
// import '../sections/product-grid/product-grid';
// import '../sections/collection-carousel/collection-carousel';

// import '../sections/creator-showcase/creator-showcase';